import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70dbf0fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "testimonials" }
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-5" }, "Meinungen", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "card h-100" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "testimonial-quote" }
const _hoisted_8 = { class: "d-block text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.testimonials, (testimonial, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-12 mb-4",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, {
                  class: "testimonial-img",
                  icon: ['fas', 'robot'],
                  size: "2x"
                }),
                _createElementVNode("p", _hoisted_7, "\"" + _toDisplayString(testimonial.quote) + "\"", 1),
                _createElementVNode("cite", _hoisted_8, "— " + _toDisplayString(testimonial.author) + ", " + _toDisplayString(testimonial.position), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}